import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dialog } from '@unite-us/ui';
import { PortalizedDialog } from '@unite-us/app-components';
import UploadedDocumentPdf from './UploadedDocumentPdf';
import PreviewUnavailableCard from './PreviewUnavailableCard';
import getFileExtension from './utils/getFileExtension';
import supportedFilesExtensions from './utils/supportedFilesExtensions';

class UploadedDocumentModal extends Component {
  render() {
    const {
      doc,
      documentClicked,
      styles,
      shouldPortalizeDialogs,
    } = this.props;

    const isDocumentSupported = supportedFilesExtensions.includes(getFileExtension(doc?.name || doc?.filename));

    return !documentClicked ? null : (
      <PortalizedDialog isOpen={documentClicked} shouldPortal={shouldPortalizeDialogs}>
        <Dialog
          id="upload-document-modal"
          ref={(el) => { this.dialog = el; }}
          title={doc.title}
          size="large"
          style={styles.dialogRoot}
          repositionOnUpdate={false}
        >
          {isDocumentSupported ?
            (
              <UploadedDocumentPdf
                doc={doc}
                pdfDocUrl={doc.pdf_url}
                UploadedDocumentPdf
              />
            ) : (
              <PreviewUnavailableCard
                doc={doc}
              />
          )}
        </Dialog>
      </PortalizedDialog>
    );
  }
}

UploadedDocumentModal.propTypes = {
  documentClicked: PropTypes.bool.isRequired,
  doc: PropTypes.shape({
    pdf_url: PropTypes.string,
    title: PropTypes.string,
    filename: PropTypes.string,
    name: PropTypes.string,
  }),
  styles: PropTypes.object.isRequired,
  shouldPortalizeDialogs: PropTypes.bool,
};

UploadedDocumentModal.defaultProps = {
  styles: {
    dialogRoot: {
      paddingTop: '10px',
    },
  },
  shouldPortalizeDialogs: false,
};

export default UploadedDocumentModal;
